import e from"styled-components";import{theme as t}from"../../../../../theme.js";const i=e.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    text-decoration: none;
    color: inherit;
  }
`,o=e.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  align-items: center;
  grid-gap: ${t.spacing*2}px;
  .displayName {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${t.colors.gray[900]};
  }
`;export{o as AuthorContainer,i as Container};
